// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2TJWb","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__kapYS"};